import {DatalakeEvent} from './abstract/datalake-event';

export class GenericEvent implements DatalakeEvent {
    private static USER_ACTION_TYPE = 'user-action';
    private static SYSTEM_ACTION_TYPE = 'system-action';
    private static TRANSFER_GENERIC_EVENT = 'transfer_generic_event';

    readonly type: string;
    readonly label: string;
    readonly action: string;
    readonly data: any;

    constructor(
        type: string,
        label: string,
        action: string,
        data?: any
    ) {
        this.type = type;
        this.label = label;
        this.action = action;
        this.data = data || {};
    }

    public get datalakeTopicName(): string {
        return GenericEvent.TRANSFER_GENERIC_EVENT;
    }

    public get datalakeTopicBody(): any {
        return {
            type: this.type,
            label: this.label,
            action: this.action,
            data: this.data
        };
    }

    public static newUserAction(label: string, action: string, data?: any): GenericEvent {
        return new GenericEvent(
            GenericEvent.USER_ACTION_TYPE,
            label,
            action,
            data
        );
    }

    public static newSystemAction(label: string, action: string, data?: any): GenericEvent {
        return new GenericEvent(
            GenericEvent.SYSTEM_ACTION_TYPE,
            label,
            action,
            data
        );
    }
}
